<template>
  <el-card class="box-card">
    <img
      src="../../../assets/product-sample@2x.jpg"
      style="width: 100%"
      alt=""
    />
    <img
      v-if="isRakutenProduct"
      src="../../../assets/rakuten@2x.jpg"
      style="width: 40px"
      alt=""
    />
    <img v-else src="../../../assets/yahoo@2x.jpg" style="width: 40px" alt="" />
    <span class="rakuten-img-text">{{ name }}</span>
    <p class="rakuten-desc">
      {{ description }}
    </p>
    <p class="rakuten-price">
      {{ price }} <small>{{ discountPrice }}</small>
    </p>
  </el-card>
</template>

<script>
export default {
  props: [
    "name",
    "image",
    "description",
    "price",
    "discountPrice",
    "isRakutenProduct",
  ],
};
</script>

<style>
.rakuten .box-card,
.yahoo .box-card {
  border-radius: 12px !important;
  height: 100% !important;
}

.rakuten-img-text {
  font-size: 12px;
  color: #ea3e3e;
}

.rakuten-desc {
  font-size: 14px;
  line-height: 20px;
  font-weight: 700;
  margin-bottom: 2rem;
}

.rakuten-price {
  font-size: 16px;
  font-weight: bold;
  color: #7a3d87;
}

.rakuten-price small {
  font-size: 12px;
  color: #7e7e7e;
}

.rakuten .el-carousel__arrow,
.yahoo .el-carousel__arrow {
  background-color: #fff !important;
  color: black !important;
}

.rakuten .el-carousel__arrow.el-carousel__arrow--left,
.yahoo .el-carousel__arrow.el-carousel__arrow--left {
  left: 160px !important;
  box-shadow: 0px 0px 11px 2px rgba(0, 0, 0, 0.33);
}

.rakuten .el-carousel__arrow.el-carousel__arrow--left:hover,
.yahoo .el-carousel__arrow.el-carousel__arrow--left:hover {
  box-shadow: 0px 0px 11px 2px rgba(0, 0, 0, 0.898);
}

.rakuten .el-carousel__arrow.el-carousel__arrow--right,
.yahoo .el-carousel__arrow.el-carousel__arrow--right {
  right: 160px !important;
  box-shadow: 0px 0px 11px 2px rgba(0, 0, 0, 0.33);
}

.rakuten .el-carousel__arrow.el-carousel__arrow--right:hover,
.yahoo .el-carousel__arrow.el-carousel__arrow--right:hover {
  box-shadow: 0px 0px 11px 2px rgba(0, 0, 0, 0.898);
}
</style>